/**
 * The line in front of a message whose sender changed in a shared session.
 *
 * One parser for the server, the scanner and the UI: what the scanner reads as "the other person
 * said this" is what the divider draws, and neither can drift from the other. Only the server
 * writes this line -- `POST /:id/messages` refuses a message that starts with one, because the
 * scanner files what follows it under the person it names.
 */
const HANDOVER = /^\[(.+) took over this shared conversation from (.+)\]\n\n/;

export function handoverLine(to: string, from: string): string {
	return `[${to} took over this shared conversation from ${from}]`;
}

export function parseHandover(text: string): { to: string; from: string; rest: string } | null {
	const match = HANDOVER.exec(text);
	return match ? { to: match[1]!, from: match[2]!, rest: text.slice(match[0].length) } : null;
}

/** Whether a message opens with a handover line, whoever it names. */
export function looksLikeHandover(text: string): boolean {
	return HANDOVER.test(text);
}
